export class Module {
    constructor(app) {
        this.app = app;
    }

    boot(app) {}

    ready(app) {}
}

export class Application {
    constructor(options = {}) {
        this.options = options;
        this.modules = [];
        this.ready = document.readyState === 'complete';

        if (!this.ready) {
            document.addEventListener('DOMContentLoaded', () => {
                this.ready = true;
                this.modules.forEach((module) => this.boot(module));
            });
        }
    }

    boot(module) {
        Promise.resolve(module.boot(this)).then((result) => {
            module.ready(this, result);
        }).catch((reason) => {
            if (reason instanceof Error) {
                console.error(reason);
            }
        });
    }

    use(factory) {
        const module = new factory(this);

        this.modules.push(module);

        if (this.ready) {
            this.boot(module);
        }
    }
}
